import React from "react";

function Footer() {
  return (
    <>
      {/* Footer Start */}
      <div
        className="container-fluid bg-dark text-light mt-5 wow fadeInUp"
        data-wow-delay="0.1s"
      >
        <div className="container">
          <div className="row gx-5">
            <div className="col-lg-4 col-md-6 footer-about">
              <div
                className="d-flex flex-column align-items-center justify-content-center text-center h-100 bg-primary p-4"
              >
                <a href="/" className="navbar-brand">
                  <h1 className="m-0 text-white">
                    Brand Lift
                  </h1>
                </a>
                <p className="mt-3 mb-4">
                  "Brand Lift is a one stop shop for all your digital marketing needs" means a comprehensive solution or service that addresses every aspect of your digital marketing requirements in a single place.
                </p>
                <form action="">
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control border-white p-3"
                      placeholder="Your Email"
                    />
                    <button className="btn btn-dark">Sign Up</button>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-8 col-md-6">
              <div className="row gx-5">
                <div className="col-lg-4 col-md-12 pt-5 mb-5">
                  <div
                    className="section-title section-title-sm position-relative pb-3 mb-4"
                  >
                    <h3 className="text-light mb-0">Get In Touch</h3>
                  </div>
                  <div className="d-flex mb-2">
                    <i className="bi bi-geo-alt text-primary me-2"></i>
                    <p className="mb-0">CBD Building, Near Sharaf DG Metro Station, Dubai, UAE.</p>
                  </div>
                  <div className="d-flex mb-2">
                    <i className="bi bi-envelope-open text-primary me-2"></i>
                    <p className="mb-0">info@brandliftmm.com</p>
                  </div>
                  <div className="d-flex mb-2">
                    <i className="bi bi-telephone text-primary me-2"></i>
                    <p className="mb-0">+971 55 730 6504</p>
                  </div>
                  <div className="d-flex mt-4">
                    <button 
                      className="btn btn-primary btn-square me-2"
                      onClick={() => window.open('https://twitter.com', '_blank')}
                    >
                      <i className="fab fa-twitter fw-normal"></i>
                    </button>
                    <button 
                      className="btn btn-primary btn-square me-2"
                      onClick={() => window.open('https://facebook.com', '_blank')}
                    >
                      <i className="fab fa-facebook-f fw-normal"></i>
                    </button>
                    <button 
                      className="btn btn-primary btn-square me-2"
                      onClick={() => window.open('https://linkedin.com', '_blank')}
                    >
                      <i className="fab fa-linkedin-in fw-normal"></i>
                    </button>
                    <button 
                      className="btn btn-primary btn-square"
                      onClick={() => window.open('https://instagram.com', '_blank')}
                    >
                      <i className="fab fa-instagram fw-normal"></i>
                    </button>
                  </div>
                </div>
                <div className="col-lg-4 col-md-12 pt-0 pt-lg-5 mb-5">
                  <div
                    className="section-title section-title-sm position-relative pb-3 mb-4">
                    <h3 className="text-light mb-0">Quick Links</h3>
                  </div>
                  <div
                    className="link-animated d-flex flex-column justify-content-start">
                    <a className="text-light mb-2" href="/"
                      ><i className="bi bi-arrow-right text-primary me-2"></i>Home</a>
                    <a className="text-light mb-2" href="/about"
                      ><i className="bi bi-arrow-right text-primary me-2"></i>About
                    </a>
                    <a className="text-light mb-2" href="/services"
                      ><i className="bi bi-arrow-right text-primary me-2"></i>
                      Services</a>
                    <a className="text-light mb-2" href="/blog"
                      ><i className="bi bi-arrow-right text-primary me-2"></i>
                      Blog</a
                    >
                    <a className="text-light" href="/contact"
                      ><i className="bi bi-arrow-right text-primary me-2"></i>Contact
                      </a>
                  </div>
                </div>
                <div className="col-lg-4 col-md-12 pt-0 pt-lg-5 mb-5">
                  <div
                    className="section-title section-title-sm position-relative pb-3 mb-4"
                  >
                    <h3 className="text-light mb-0">Popular Links</h3>
                  </div>
                  <div
                    className="link-animated d-flex flex-column justify-content-start"
                  >
                    <span className="text-light mb-2 d-flex align-items-center"
                      ><i className="bi bi-arrow-right text-primary me-2"></i>Search Engine Optimization
                      </span>
                    <span className="text-light mb-2 d-flex align-items-center"
                      ><i className="bi bi-arrow-right text-primary me-2"></i>Search Engine Marketing
                      </span>
                    <span className="text-light mb-2 d-flex align-items-center"
                      ><i className="bi bi-arrow-right text-primary me-2"></i>Social Media Optimization
                      </span>
                    <span className="text-light mb-2 d-flex align-items-center"
                      ><i className="bi bi-arrow-right text-primary me-2"></i>Social Media Marketing
                      </span>
                    <span className="text-light mb-2 d-flex align-items-center"
                      ><i className="bi bi-arrow-right text-primary me-2"></i>Web Development</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid text-white" style={{backgroundColor: "#061429"}}>
        <div className="container text-center">
          <div className="row justify-content-end">
            <div className="col-lg-8 col-md-6">
              <div
                className="d-flex align-items-center justify-content-center"
                style={{height: "75px"}}>
                <p className="mb-0">
                  &copy;
                  <a className="text-white border-bottom border-primary" href="#">Brand Lift. </a>
                     All Rights Reserved. Designed & Maintained by 

                  <a className="text-white border-bottom border-primary" href="https://www.sfwebsolutions.in"
                    > SFwebsolutions </a
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer End */}

      {/* Back to Top */}
      <button 
        className="btn btn-lg btn-primary btn-lg-square rounded back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000 }}
      >
        <i className="bi bi-arrow-up"></i>
      </button>
    </>
  );
}

export default Footer;
